import UploadLogotipo from '@/components/layout/uploadImagem/UploadLogotipo.vue'
import InformacoesEmpresariais from '@/views/escritorios/InformacoesEmpresariais'
import InformacoesPessoais from '@/views/escritorios/InformacoesPessoais'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'informacoes',
  props: {
    desabilitarCampos: Boolean,
    buscarInformacoesDoCnpj: Function,
    enderecoLogotipo: {
      type: [String],
      required: false,
      default: null
    }
  },
  components: {
    UploadLogotipo,
    InformacoesEmpresariais,
    InformacoesPessoais
  },

  computed: {
    ...mapState('escritorios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'mostrarModalConfirmacao']),
    ehPessoaFisica () {
      return this.formulario.tipo === 1
    },
    ehPessoaJuridica () {
      return this.formulario.tipo === 2
    },
    obterLabelTipoPessoa () {
      return this.ehPessoaFisica ? 'CPF' : 'CNPJ'
    },
    logotipo: {
      get () {
        return { codigoBase64: null, urlExterna: this.enderecoLogotipo }
      }
    }
  },

  data: () => {
    return {
      comboTiposPessoa: [
        { id: 1, nome: 'Pessoa Física' },
        { id: 2, nome: 'Pessoa Jurídica' }
      ]
    }
  },

  methods: {
    ...mapActions('escritorios', [
      'ActionResetarDadosAbasCadastro',
      'ActionResetarDadosRetornoCadastro'
    ]),
    receberDadosUploadLogotipo (dadosArquivo) {
      this.formulario.informacoes.logotipo = null
      this.formulario.informacoes.logotipo = dadosArquivo
    },
    limparListaErros () {
      this.ActionResetarDadosRetornoCadastro()
    }
  }
}
